import React from 'react';
import CustomerKnowlegeBase from '../CustomerKnowlegeBase';

export default function CustomerKnowlegePage() {
  return (
    <CustomerKnowlegeBase />
  );
}
